function caseStudiesFunc() {
	const currentUrl = window.location.pathname;
	const caseFilter = jQuery('.archive-case-studies__filter');
	const mobFilterBtn = jQuery('.archive-case-studies__filter-button');
	const filterDropdown = jQuery('.archive-case-studies__filter-dropdown');
	let selectedFilter = '';

	if (caseFilter.length > 0) {
		caseFilter.find('ul li a').each(function () {
			const href = jQuery(this).attr('href');
			if (currentUrl === href) {
				setFilterActive(jQuery(this));
				selectedFilter = jQuery(this).html();
			} else if (currentUrl.includes(href) && href !== '/client-stories/') {
				setFilterActive(jQuery(this));
				selectedFilter = jQuery(this).html();
      }
		});

		if (selectedFilter.length > 0) {
			filterSelectedFilterText(mobFilterBtn, selectedFilter);
		}

		filterDropdown.find('a').on('click', function() {
			selectedFilter = jQuery(this).html();
			filterSelectedFilterText(mobFilterBtn, selectedFilter);
			filterClick(filterDropdown, mobFilterBtn);
		});

		mobFilterBtn.on('click', function() {
			filterClick(filterDropdown, mobFilterBtn);
		});
	}
}

function filterClick (filterDropdown, mobFilterBtn) {
	if (filterDropdown.hasClass('active')) {
		filterDropdown.removeClass('active');
		mobFilterBtn.removeClass('active');
	} else {
		filterDropdown.addClass('active');
		mobFilterBtn.addClass('active');
	}
}

function filterSelectedFilterText(mobFilterBtn, selectedFilter) {
	if (window.innerWidth > 768) {
		mobFilterBtn.find('span').html(selectedFilter);
	} else {
		//const filteredText = selectedFilter.split('<span')[0].replace(/^By\s/, '');
		mobFilterBtn.find('span').html(selectedFilter);
	}
}

function setFilterActive (element) {
	element.parent().addClass('active');
}

function caseStudies() {
	caseStudiesFunc();
}

export default caseStudies;
